import instance from "./request";

//查找配置项
export const configDetailAll = (data) => instance.get('/config/configDetailAll', { params: data })


export const personPage = (data) => instance.get('/person/page', { params: data })
//新增人员
export const addPerson = (data) => instance.post('/person/add', data)
//修改人员
export const editPerson = (data) => instance.post('/person/edit', data)
//人员详情
export const personInfo = (id, project_id) => instance.get('/person/info/' + id + '/' + project_id)

//获取人员设置
export const personRule = () => instance.get('/person/rule')

//修改人员设置
export const personRuleSet = (data) => instance.post('/person/ruleSet', data)

//人员签字
export const personSign = (data) => instance.post('/person/sign', data)

//根据人员身份证号查询详情
export const personIdinfo = (data) => instance.post('/person/idinfo', data)

//批量导入人员
export const batchAdd = (data) => instance.post('/person/batchAdd', data)

//退场
export const exitPerson = (data) => instance.post('/person/exit', data)

//批量分配分包单位
export const resetCompanyId = (data) => instance.post('/person/resetCompanyId', data)

